import React, { FC, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
import { useTheme, withTheme } from '@shared/lib';
interface Props {
  type?: 'default' | 'warning';
  bgColor?: string;
  width?: string;
}
const DefaultIcon = () => {
  const theme = useTheme();
  return <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.68597 19.314C3.3731 18.0012 3.27575 16.6932 3.08105 14.0772C3.03058 13.399 3 12.6995 3 12C3 11.3005 3.03058 10.601 3.08105 9.92282C3.27575 7.30684 3.3731 5.99884 4.68597 4.68597C5.99884 3.37309 7.30684 3.27575 9.92282 3.08105C10.601 3.03058 11.3005 3 12 3C12.6995 3 13.399 3.03058 14.0772 3.08105C16.6932 3.27575 18.0012 3.37309 19.314 4.68597C20.6269 5.99884 20.7243 7.30684 20.9189 9.92282C20.9694 10.601 21 11.3005 21 12C21 12.6995 20.9694 13.399 20.9189 14.0772C20.7243 16.6932 20.6269 18.0012 19.314 19.314C18.0012 20.6269 16.6932 20.7243 14.0772 20.9189C13.399 20.9694 12.6995 21 12 21C11.3005 21 10.601 20.9694 9.92282 20.9189C7.30684 20.7243 5.99884 20.6269 4.68597 19.314ZM12 13C12.5523 13 13 12.5523 13 12L13 8.00244C13 7.45015 12.5523 7.00244 12 7.00244C11.4477 7.00244 11 7.45016 11 8.00244L11 12C11 12.5523 11.4477 13 12 13ZM13.2477 16.0011C13.2477 15.3114 12.6886 14.7523 11.9989 14.7523C11.3091 14.7523 10.75 15.3114 10.75 16.0011C10.75 16.6909 11.3091 17.25 11.9989 17.25C12.6886 17.25 13.2477 16.6909 13.2477 16.0011Z" fill={theme.colors.icon.warning} />
    </svg>;
};
const WarningIcon = () => {
  const theme = useTheme();
  return <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_428_16369)">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.68597 17.314C1.3731 16.0012 1.27575 14.6932 1.08105 12.0772C1.03058 11.399 1 10.6995 1 10C1 9.30048 1.03058 8.60095 1.08105 7.92282C1.27575 5.30684 1.3731 3.99884 2.68597 2.68597C3.99884 1.37309 5.30684 1.27575 7.92282 1.08105C8.60095 1.03058 9.30048 1 10 1C10.6995 1 11.399 1.03058 12.0772 1.08105C14.6932 1.27575 16.0012 1.37309 17.314 2.68597C18.6269 3.99884 18.7243 5.30684 18.9189 7.92282C18.9694 8.60095 19 9.30048 19 10C19 10.6995 18.9694 11.399 18.9189 12.0772C18.7243 14.6932 18.6269 16.0012 17.314 17.314C16.0012 18.6269 14.6932 18.7243 12.0772 18.9189C11.399 18.9694 10.6995 19 10 19C9.30048 19 8.60095 18.9694 7.92282 18.9189C5.30684 18.7243 3.99884 18.6269 2.68597 17.314ZM10 11C10.5523 11 11 10.5523 11 9.99999L11 6.00244C11 5.45015 10.5523 5.00244 9.99998 5.00244C9.4477 5.00244 8.99999 5.45016 8.99999 6.00244L9 9.99999C9 10.5523 9.44772 11 10 11ZM11.2477 14.0011C11.2477 13.3114 10.6886 12.7523 9.99887 12.7523C9.30914 12.7523 8.75 13.3114 8.75 14.0011C8.75 14.6909 9.30914 15.25 9.99887 15.25C10.6886 15.25 11.2477 14.6909 11.2477 14.0011Z" fill={theme.colors.icon.warning} />
      </g>
      <defs>
        <clipPath id="clip0_428_16369">
          <rect width="20" height="20" fill={theme.colors.icon.white} />
        </clipPath>
      </defs>
    </svg>;
};
export const AlertBanner: FC<PropsWithChildren<Props>> = ({
  type = 'default',
  bgColor,
  width,
  children
}) => <Wrapper bgColor={bgColor} width={width}>
    <IconWrapper>{type === 'warning' ? <WarningIcon /> : <DefaultIcon />}</IconWrapper>
    <Text>{children}</Text>
  </Wrapper>;
interface WrapperProps {
  bgColor?: string;
  width?: string;
}
const _exp = /*#__PURE__*/() => ({
  bgColor,
  theme
}) => bgColor || theme.colors.bg.tertiary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp3 = /*#__PURE__*/() => ({
  width
}) => width || 'none';
const Wrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "w1533oz2",
  propsAsIs: false,
  vars: {
    "w1533oz2-0": [_exp()],
    "w1533oz2-1": [_exp2()],
    "w1533oz2-2": [_exp3()]
  }
}));
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "t1uzxtm7",
  propsAsIs: false,
  vars: {
    "t1uzxtm7-0": [_exp4()],
    "t1uzxtm7-1": [_exp5(), "px"],
    "t1uzxtm7-2": [_exp6()],
    "t1uzxtm7-3": [_exp7(), "px"]
  }
}));
const IconWrapper = /*#__PURE__*/styled('div')({
  name: "IconWrapper",
  class: "i1989ol0",
  propsAsIs: false
});

require("./AlertBanner.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./AlertBanner.tsx");